import styled from "styled-components";

export const WrapperTabs = styled.div`
  font-size: 16px;
  font-weight: 500;
  line-height: 16px;
  text-align: left;

  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: #6610f2 !important;
    text-shadow: 0 0 0.25px currentcolor;
  }

  .ant-tabs-tab-btn:hover {
    color: #8b44ff !important;
  }
  .ant-tabs-tab-btn {
    padding: 0px 25px;
  }
  .ant-tabs-tab + .ant-tabs-tab {
    margin: 0 0 0 0px;
  }
  .ant-tabs-ink-bar {
    background: #6610f2;
  }

  .ant-tabs-tab-btn:focus,
  .ant-tabs-tab-remove:focus,
  .ant-tabs-tab-btn:active,
  .ant-tabs-tab-remove:active {
    color: #8b44ff !important;
  }
`;
